import { platformBrowser } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { AppModule } from 'app/app.module';

console.info("p", environment.isProduction);
console.info("v", environment.version);

platformBrowser().bootstrapModule(AppModule)
                 .catch(err => console.error(err));
